var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control all-day-input",attrs:{"id":_vm.id,"name":_vm.name},on:{"change":_vm.changePartOfDay}},_vm._l((_vm.parts),function(part,i){return _c('option',{attrs:{"data-start":part[0],"data-end":part[1]},domProps:{"selected":_vm.value==part[2]}},[_vm._v("\n    "+_vm._s(part[2])+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }